import { Img } from "components";
import { useEffect, useRef, useState } from "react";
import BhashaniVideo from "../components/BhashaniVideo";
import CommunicationModal from "../components/CommunicationModal";
import axios from "axios";
import { Button } from "components/Button";
import * as ModalR from 'react-modal';
import AvatarVideo from "../components/AvatarVideo";
import { useGlobalState } from "components/GlobalState";
import Wrapper from "../components/Wrapper";
import { languageObject, API_HOST } from "utils";
import Modal from 'react-modal';
import AudioPlayer from "../components/AudioPlayer";
import { showGlobalModal } from "components/GlobalModal";

const LIVE_DEMO_MODULES = [
    { name: "Welcome Note", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "App Downloads", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Social Hub", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "School Reopen Date", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Book Collection", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Dress Collection", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Attendance", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Exam Timetable", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Exam Results", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Fee Reminder", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Fee Follow Up", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Fee Delay Penalty", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "PTM", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Birthdays", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] },
    { name: "Other Announcements", language: [{ name: "English", url: "" }, { name: "Telugu", url: "" }, { name: "Hindi", url: "" }] }
];



function extractKeysAndValues(dataArray) {
    const keys = [];
    const values = [];

    dataArray.forEach(obj => {
        const [key, value] = Object.entries(obj)[0]; // get the first key-value pair
        keys.push(Number(key));
        values.push(value);
    });

    return { keys, values };
}

const customStylesRefer = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "50rem", // Adjusted for responsiveness
        maxWidth: "90%", // Added to maintain a max width
        minHeight: "8rem",
        borderRadius: "1em",
        boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
        padding: "10px 0px",
        border: "0px",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: "999",
    },
    "@media (min-width: 768px)": {
        content: {
            width: "75%", // Adjusted for tablet view
        },
    },
    "@media (min-width: 1024px)": {
        content: {
            width: "55rem", // Original width for desktop view
        },
    },
};

const customStylesAskModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30rem',
        maxWidth: '80%',
        minHeight: '10rem',
        borderRadius: '1.5em',
        boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
        padding: '1.3rem',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999
    },
};


const customStylesAskAudioModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        maxWidth: '80%',
        minHeight: '10rem',
        borderRadius: '1.5em',
        boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
        background: "#F5F5F5"
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999
    },
};



const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/demo-comm-1.mp4" }
]

const handleCopyClick = async (textToCopy) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
};

const DummyCommunication = () => {
    // const videoRef = useRef(null);
    const intervalRef = useRef(null);
    const { videoReplayOnPageLoad, language } = useGlobalState();

    const [selectedDemoModule, setSelectedDemoModule] = useState(null);
    const [dynamicVideoLink, setDynamicVideoLink] = useState("");
    const [currentSource, setCurrentSource] = useState<any>("");
    const [communicationModal, setCommunicationModal] = useState({ display: false, DATA: {} });

    const [confirmationModal, setConfirmationModal] = useState({ display: false, data: {} });
    const [audioModal, setAudioModal] = useState(false);
    const [formLoader, setFormLoader] = useState(false);
    const [demoCampaignID, setDemoCampaignID] = useState<any>({});

    const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");

    const genrateDATA = () => {
        let demoData: any = '';

        try {
            console.log("checking");
            demoData = JSON.parse(sessionStorage.getItem('demo_data')) || "";
        } catch (err) {
            console.log("err ", err);
        }
        return demoData
    }

    const setTheSource = (source = "COMM") => {
        setCurrentSource(currentSource => source);
        if (!genrateDATA()?.DEMO_CAMPAIGN_ID && !JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            sessionStorage.setItem('demo_data', JSON.stringify({
                SOURCE: source,
                OTP: "",
                IDS: [],
                ALREADY_PLAYED: []
            }));
        } else {
            setDemoCampaignID({ ...genrateDATA(), SOURCE: source })
            sessionStorage.setItem('demo_data', JSON.stringify({
                ...genrateDATA(),
                SOURCE: source,
            }));
        }
    }

    // useEffect(() => {
    //     const checkAndRequest = async () => {
    //         const isAllow = !!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length;
    //         if (isAllow) {
    //             // Your API request logic here
    //             const query = JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.map(id => `ids=${id}`).join("&");
    //             const response = await axios.get(`${API_HOST}/master/demoCampaignDetail/callStatus?${query}`);
    //             if ([200, 201]?.includes(response?.data?.code)) {
    //                 handleVideoSaving(response?.data?.data.filter((item:any) => !!item?.[genrateDATA()?.IDS?.find(key => item[key])]))
    //             }
    //         } else {
    //             console.log('isAllow is false, stopping interval');
    //             clearInterval(intervalRef.current);
    //             intervalRef.current = null;
    //         }
    //     };

    //     // Start the interval if isAllow is true
    //     if (!!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length && !intervalRef.current) {
    //         intervalRef.current = setInterval(checkAndRequest, 6000);
    //     }

    //     // Watch for changes in sessionStorage
    //     const storageListener = () => {
    //         if (!!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length && !intervalRef.current) {
    //             intervalRef.current = setInterval(checkAndRequest, 6000);
    //         } else if (!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length && intervalRef.current) {
    //             clearInterval(intervalRef.current);
    //             intervalRef.current = null;
    //         }
    //     };

    //     window.addEventListener('storage', storageListener);

    //     return () => {
    //         clearInterval(intervalRef.current);
    //         window.removeEventListener('storage', storageListener);
    //     };
    // }, []);

    useEffect(() => {
        const checkAndRequest = async () => {
            const isAllow = !!demoCampaignID?.IDS?.length;
            if (isAllow) {
                const query = demoCampaignID.IDS.map(id => `ids=${id}`).join("&");
                const response = await axios.get(`${API_HOST}/master/demoCampaignDetail/callStatus?${query}&lang=${languageObject?.[language]}`);
                if ([200, 201].includes(response?.data?.code)) {
                    handleVideoSaving(
                        response?.data?.data.filter((item: any) =>
                            !!item?.[demoCampaignID?.IDS?.find(key => item[key])]
                        )
                    );
                }
            } else {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };

        if (!!demoCampaignID?.IDS?.length && !intervalRef.current) {
            intervalRef.current = setInterval(checkAndRequest, 6000);
        }

        return () => {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [demoCampaignID?.IDS?.join(",")]);

    useEffect(() => {
        if (!genrateDATA()?.DEMO_CAMPAIGN_ID && !JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            setTheSource();
        } else {
            setCurrentSource(genrateDATA()?.SOURCE)
            setDemoCampaignID(genrateDATA())
        }
    }, []);

    const handleSubmit = async (values) => {
        try {
            setFormLoader(true);
            if (demoCampaignID?.DEMO_CAMPAIGN_ID) {
                const payloadValue: any = {
                    ...demoCampaignID,
                    OTP: values?.OTP,
                    SALES_USER_OTP: values?.SALES_USER_OTP,
                    IDS: undefined,
                    ALREADY_PLAYED: undefined
                };

                const campaginDetailResponse = await axios.post(`${API_HOST}/master/demoCampaignDetail/insert`, payloadValue);

                sessionStorage.setItem('demo_data', JSON.stringify({
                    ...payloadValue,
                    IDS: campaginDetailResponse?.data?.data?.ids,
                    ALREADY_PLAYED: []
                }));
                sessionStorage.setItem('form_data', JSON.stringify(values));
                if ([200, 201]?.includes(campaginDetailResponse?.data?.code)) {
                    showGlobalModal(campaginDetailResponse?.data?.message);
                } else {
                    throw new Error(campaginDetailResponse?.data?.message)
                }
            }
        } catch (err) {
            console.log(err);
            showGlobalModal(err?.message, "error");
        } finally {
            setFormLoader(false);
            setConfirmationModal({ display: false, data: {} });
        }

    };

    const checkAndSubmit = async () => {
        const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};
        try {
            setFormLoader(true);
            if (!!form_data?.MOBILE_NUMBER) {
                const isDataIsAlreadyThere = await axios.get(`${API_HOST}/master/demoCampaign/check?mobile_number=${form_data?.MOBILE_NUMBER}&source=${currentSource || form_data?.SOURCE}`);
                if (isDataIsAlreadyThere?.data?.data?.exists) {
                    setConfirmationModal({ display: true, data: form_data })
                } else if (!!form_data?.MOBILE_NUMBER) {
                    handleSubmit(form_data);
                } else {
                    setCommunicationModal({ display: true, DATA: genrateDATA() || JSON.parse(sessionStorage.getItem("demo_data")) })
                }
            } else {
                setCommunicationModal({ display: true, DATA: genrateDATA() || JSON.parse(sessionStorage.getItem("demo_data")) })
            }
        } catch (err) {
            showGlobalModal(err?.message, "error");
        } finally {
            setFormLoader(false);
        }
    }

    const getSourceNames = () => {
        return currentSource === "COMM" ? "Daily Updates" : currentSource;
    }

    const handleCommunicationModal = (e) => {
        setCommunicationModal(e)
        if (!!genrateDATA()?.DEMO_CAMPAIGN_ID && !!JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            setDemoCampaignID(demoCampaignID => ({ ...genrateDATA(), SOURCE: currentSource || form_data?.SOURCE }))
            // window.location.reload()
        }
    }

    const handleVideoSaving = (videoURL: any = "") => {
        if (typeof (videoURL) === "string") {
            setDynamicVideoLink(dynamicVideoLink => videoURL)
        } else if (Array.isArray(videoURL) && !!videoURL?.length) {
            const result = extractKeysAndValues(videoURL);
            const removeKeys = genrateDATA()?.IDS?.filter(item => !result?.keys?.includes(+item))
            setDynamicVideoLink(dynamicVideoLink => result?.values?.[0])
            sessionStorage.setItem('demo_data', JSON.stringify({
                ...genrateDATA(),
                IDS: removeKeys
            }));
            setDemoCampaignID(demoCampaignID => ({ ...genrateDATA(), IDS: removeKeys }))
        }
    }

    const handleOpenModal = (bool) => {
        setSelectedDemoModule(selectedDemoModule => bool ? LIVE_DEMO_MODULES?.[0] : null);
        setAudioModal(audioModal => bool);
    }

    return (
        <Wrapper
            title={"Communications Made Easy"}
            description="🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities."
            descriptionSize="text-[2.5vh]"
            videoLinks={<AvatarVideo
                videoLinks={videoLinks}
                dynamicVideoLink={dynamicVideoLink}
                handleDynamicVideoLink={() => setDynamicVideoLink("")}
                videoLoader={"https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/rani-thumbnail.png"}
                dontPlayMainVideoOnEveryRender
            />}
            body={<>
                <Modal
                    isOpen={audioModal}
                    contentLabel="Example Modal"
                    style={customStylesAskAudioModal}
                >
                    <div className="flex justify-between mb-4">
                        <h1 className="font-bold text-xl">Live Demo</h1>
                        <button onClick={() => handleOpenModal(false)}>
                            <Img src="/images/Close.svg" alt="close" className="h-8" />
                        </button>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-4 space-y-4">
                            <p className="font-semibold text-[2vh]">Select module</p>
                            <div className="flex flex-col items-start gap-2 max-h-[30vh] overflow-y-scroll pr-2">
                                {LIVE_DEMO_MODULES?.map((item, index) => <button type="button" onClick={() => setSelectedDemoModule(item)} className={`${item?.name === selectedDemoModule?.name ? "bg-smd_blue-normal text-[white]" : ""} w-full px-4 py-2 rounded-xl text-[1.6vh] text-left`} key={"aslndakjsdnasd" + index}>{item?.name}</button>)}
                            </div>
                        </div>
                        {!!selectedDemoModule?.language?.length && <div className="col-span-8 space-y-4">
                            <p className="font-semibold text-[2vh]">Select language modules</p>
                            <div className="flex flex-wrap items-center gap-4">
                                {selectedDemoModule?.language?.map((item, index) => <AudioPlayer key={"asndajkdsbaskjdasd" + index} title={item?.name} src={item?.url} />)}
                            </div>
                        </div>}
                    </div>
                </Modal>
                {!!communicationModal?.display && <CommunicationModal
                    showModal={communicationModal}
                    customStyles={customStylesRefer}
                    setshowModal={(e) => handleCommunicationModal(e)}
                    handleVideoSaving={e => handleVideoSaving(e)}
                />}
                {!!confirmationModal.display && <ModalR
                    isOpen={confirmationModal.display}
                    contentLabel="Example Modal"
                    style={customStylesAskModal}
                >
                    <div className="flex justify-between">
                        <h1 className="font-bold text-xl">Confirmation</h1>
                        <button onClick={() => setConfirmationModal({ display: false, data: {} })}>
                            <Img src="/images/Close.svg" alt="close" className="h-8" />
                        </button>
                    </div>
                    <p className="text-medium text-md text-neutral-70 my-[1.5em]">
                        The {getSourceNames()} demo for this number has already been completed. Are you sure you want to proceed with another demonstration?
                    </p>
                    <div className="flex justify-end">
                        <div className="flex gap-2">
                            <Button
                                size="sm"
                                type="button"
                                className="font-manropeSB rounded-lg"
                                onClick={() => {
                                    setConfirmationModal({ display: false, data: {} });
                                }}
                            >
                                No
                            </Button>
                            {formLoader ? <div>
                                <Img src="images/loader.gif" alt="loader" className="h-10" />
                            </div> : <button
                                onClick={() => {
                                    handleSubmit(confirmationModal?.data);
                                }}
                                title="Send OTP"
                                type="button"
                                className={`bg-smd_blue-normal text-[white] py-2 px-4 rounded-2xl`}>
                                Yes
                            </button>}
                        </div>
                    </div>
                </ModalR>}
                <div className="font-inter text-center space-y-4">
                    <h2 className="text-smd_blue-normal font-manropeB text-[3vh]">Inspired by PM Narendra Modi’s Vision</h2>
                    <p className={`text-[2vh]`}><span className="font-manropeB text-[black]">Our Prime Minister launched Bhashini </span>to empower Indians to communicate in their regional languages. we embrace this <br />mission by ensuring seamless communication <span className="font-manropeB">in parents' preferred language.</span></p>
                </div>
                <div className="grid grid-cols-12 gap-4 w-full">
                    <div className="col-span-5">
                        <BhashaniVideo />
                    </div>
                    <div className="font-inter col-span-7 flex flex-col justify-center items-center gap-y-6 border-2 border-smd_blue-light rounded-xl p-4">
                        <div className="text-center space-y-2">
                            <h2 className="text-smd_blue-dark font-manropeB text-[3vh]">Experience Auto Connect – Our 3 way Communication</h2>
                            <p className="text-[2vh]">See how automated calls/sms/whatsApp bridge the communication gap.</p>
                        </div>
                        <div className="w-full flex flex-col items-center gap-4 text-[2vh]">
                            {/* <div className="flex items-center gap-4">
                                <button type="button" className={`border border-[black] rounded-xl py-2 px-4 ${currentSource === "COMM" ? "bg-smd_blue-dark text-[white]" : ""}`} onClick={() => setTheSource("COMM")}>Daily Updates</button>
                                <button type="button" className={`border border-[black] rounded-xl py-2 px-4 ${currentSource === "FEEDBACK" ? "bg-smd_blue-dark text-[white]" : ""}`} onClick={() => setTheSource("FEEDBACK")}>Feedback</button>
                                <button type="button" className={`border border-[black] rounded-xl py-2 px-4 ${currentSource === "FEE" ? "bg-smd_blue-dark text-[white]" : ""}`} onClick={() => setTheSource("FEE")}>Fee Follow Up</button>
                            </div> */}
                            {formLoader ? <div>
                                <Img src="images/loader.gif" alt="loader" className="h-10" />
                            </div> : <button onClick={() => handleOpenModal(true)} type="button" className={`text-[2.5vh] py-4 px-6 bg-smd_blue-dark font-thin text-gray-200 rounded-xl ${/* !videoReplayOnPageLoad?.includes(window.location.pathname) */false ? "cursor-progress" : ""}`}>
                                Experience Live Demo
                            </button>}
                            <p className="text-[2vh] text-smd_blue-dark">Takes less than 30 seconds</p>
                        </div>
                        <p className="flex gap-1 text-[2vh]">
                            Save this number
                            <span className="text-smd_blue-dark underline decoration-dotted font-manropeB tracking-widest">+91 8065195555</span>
                            <button type="button" onClick={() => handleCopyClick("+918065195555")}>
                                <Img src="images/soomuch-demo/copy.svg" className="h-5" />
                            </button>
                            you’ll get a call from it soon!
                        </p>
                    </div>
                </div>
            </>}
        />
    );
}

export default DummyCommunication;